import React from 'react';
import { Domingo } from '@fiverr-private/domingo';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Section, Stack, Container } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { ClientsRate } from '../../../shared/types';
import { sendBqEvent } from '../../../events/bigQuery';
import { Content } from '../Content';
import { headerContainer } from './styles.ve.css';

const TRANSLATIONS_KEY = 'skill_page_perseus.hero_banner';

interface Props {
    category: ClientsRate['category'];
    professionAliasPlural: string;
    slug?: string;
    title: string;
    description: string;
    isDefaultLocale: boolean;
    hostUrl: string;
}

export const ProHeroBanner: React.FC<Props> = ({
    category,
    title,
    description,
    professionAliasPlural,
    slug,
    isDefaultLocale,
    hostUrl,
}) => {
    const italicTemplate = {
        italic: (text: string | undefined) => <em>{text}</em>,
    };

    const onClick = () => {
        sendBqEvent('user_action', {
            type: 'seo_pro_listing_click',
            actionType: 'click',
            element: {
                type: 'button',
                text: 'hire pro freelancer',
                name: slug,
            },
        });
    };

    const href = Domingo(hostUrl)
        .pro()
        .path('search_gigs', undefined, {
            query: { query: category, source: 'skill_pages' },
        }).url;

    return (
        <Section
            backgroundColor="business_100"
            fullWidth
            paddingTop={{ default: '7', sm: '8', md: '14' }}
            paddingBottom={{ default: '9', sm: '8', md: '16' }}
        >
            <Stack
                direction="column"
                centered
                gap="0"
                paddingTop="0"
                paddingBottom="0"
                padding="0"
                paddingLeft="8"
                paddingRight="6"
            >
                {title ? (
                    <Container marginBottom={{ default: '1', sm: '2' }}>
                        <Content className={headerContainer} isIndependent={true} color="grey_1200" plainHtml={title} />
                    </Container>
                ) : (
                    <Typography className={headerContainer} as="h1" marginBottom={{ default: '1', sm: '2' }}>
                        <I18n
                            k={`${TRANSLATIONS_KEY}.${isDefaultLocale ? 'title' : 'title_localized'}`}
                            params={{ category: professionAliasPlural }}
                            templates={italicTemplate}
                        />
                    </Typography>
                )}
                <Text>
                    {description ? (
                        <Content isIndependent={true} color="grey_1200" plainHtml={description} />
                    ) : (
                        <I18n
                            k={`${TRANSLATIONS_KEY}.${isDefaultLocale ? 'description' : 'description_localized'}`}
                            params={{ category: professionAliasPlural }}
                        />
                    )}
                </Text>
                <Container>
                    <Container marginTop={{ default: '5', md: '7' }}>
                        <Button onClick={onClick} href={href} rel="nofollow" size="md">
                            <I18n k={`${TRANSLATIONS_KEY}.cta`} />
                        </Button>
                    </Container>
                </Container>
            </Stack>
        </Section>
    );
};
